import {useCallback, useReducer, useRef} from 'react';
import {CLASS_REDUCER} from './useMemorized.enum';

/**
 * useMemorizedReducer - hooks of useReducer (improved)
 * @param reducer - reducer function
 * @param initState - the state
 */
export const useMemorizedReducer = (reducer, initState) => {
    const lastState = useRef(initState);
    const getState = useCallback(() => lastState.current, []);

    return [
        ...useReducer(
            (state, action) => lastState.current = reducer(state, action),
            initState
        ),
        getState
    ];
};

/**
 * reducer - reducer custom function (default set state without other actions)
 * @param state - new satae
 * @param action - action name
 */
export const reducer = (state, action) => {
    switch (action.type) {
        case CLASS_REDUCER.CHANGE_STATE:
            return action.state;
        default: return state;
    }
};

/**
 * useSetStateReducer - custom hook for the full process
 * @param reducer- reducer function
 * @param initializeState - first stage of state
 */
export const useSetStateReducer = (reducer, initializeState) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [_, dispatch, getState] = useMemorizedReducer(reducer, initializeState);

    /**
     * setState - set configuration page
     * @param newState - state to replace
     */
    const setState = (newState) => {
        dispatch({type: 'changeState', state: {
            ...getState(),
            ...newState
        }});
    };

    return [getState, setState];
};
